import { render, staticRenderFns } from "./ProductSearchAreaSale.vue?vue&type=template&id=1d18d8a7&scoped=true&"
import script from "./ProductSearchAreaSale.vue?vue&type=script&lang=js&"
export * from "./ProductSearchAreaSale.vue?vue&type=script&lang=js&"
import style0 from "./ProductSearchAreaSale.vue?vue&type=style&index=0&id=1d18d8a7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d18d8a7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
